<template>
	<section class="form form__vertical container__booking">
		<div class="form__heading">
			<h1 class="heading-title">{{ $t('auth.password_recovery') }}</h1>
			<h2 class="content-default">{{ $t('auth.password_recovery_caption') }}</h2>
		</div>
		<form class="form__input flex-vertical left-align" @submit.prevent="validateForm" @keydown="form.onKeydown($event)">
			<label for="email" class="label">
				<b>{{ $t('fields.email') }}</b>
			</label>

			<input
				v-model="form.email"
				:class="{ 'is-danger': form.errors.has('email') }"
				class="input"
				type="email"
				name="email"
				:placeholder="$t('fields.email')"
			/>

			<label for="password" class="label">
				<b>{{ $t('fields.password') }}</b>
			</label>

			<input
				name="password"
				type="password"
				v-model="form.password"
				class="input"
				:class="{ 'is-danger': form.errors.has('password') }"
				:placeholder="$t('fields.password')"
			/>

			<label for="password_confirmation" class="label">
				<b>{{ $t('fields.password_confirmation') }}</b>
			</label>

			<input
				name="password_confirmation"
				type="password"
				v-model="form.password_confirmation"
				class="input"
				:class="{ 'is-danger': form.errors.has('password_confirmation') }"
				:placeholder="$t('fields.password_confirmation')"
			/>

			<v-button :loading="form.busy" :disabled="!form.email || !form.password || !form.password_confirmation">
				{{ $t('auth.password_reset') }}
			</v-button>
		</form>
	</section>
</template>

<script>
import Form from 'vForm'

export default {
	// middleware: 'guest',

	metaInfo() {
		return { title: this.$t('auth.password_recovery') }
	},

	data: () => ({
		status: null,
		form: new Form({
			token: null,
			email: null,
			password: null,
			password_confirmation: null,
		}),
	}),

	created() {
		this.form.email = this.$route.query.email
		this.form.token = this.$route.params.token
	},

	methods: {
		validateForm() {
			let { email, password, password_confirmation } = this.form

			if (!email) this.form.errors.set('email', this.$t('validation.field_is_required', [this.$t('fields.email')]))
			if (!password) this.form.errors.set('password', this.$t('validation.field_is_required', [this.$t('fields.password')]))

			if (!password_confirmation)
				this.form.errors.set('password_confirmation', this.$t('validation.field_is_required', [this.$t('fields.password_confirmation')]))

			if (password && password !== password_confirmation)
				this.form.errors.set('password', this.$t('validation.password_confirmation_not_match'))

			if (!this.form.errors.any()) this.reset()
			else this.$notifyAllErrors(this.form.errors.all())
		},
		async reset() {
			try {
				this.$store.commit('auth/LOGOUT')
				let { data } = await this.form.post('/password/reset')
				this.$notify(data.message, 'success')
				this.form.reset()
				this.$router.push({ name: 'login' })
			} catch ({ response }) {
				// this.$notify(response.data.message)
				this.$notifyAllErrors(response.data.errors)
			}
		},
	},
}
</script>
